<template>
    <div class="grid grid-cols-1 gap-3 md:grid-cols-2 xl:grid-cols-4">
        <div v-for="index in 20" :key="index">
            <div class="rounded-sm px-2 py-2">
                <div class="my-[1px] h-32 w-full animate-pulse rounded bg-slate-200" />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'SkeletonReports',
}
</script>
